"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Flex = require("../Flex");

var _Modal = require("../Modal");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Dialog.
 * Spec: https://app.zeplin.io/project/5acd19ff49a1429169c3128b/screen/5b9a7bdaa2fa5551fff7c014
 */
var Dialog = function Dialog(_ref) {
  var title = _ref.title,
      detail = _ref.detail,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? true : _ref$show,
      primaryCta = _ref.primaryCta,
      secondaryCta = _ref.secondaryCta,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return null;
  } : _ref$onClose;
  var StyledSans = (0, _styledComponents.default)(_Typography.Sans).withConfig({
    displayName: "Dialog__StyledSans",
    componentId: "fisnsh-0"
  })(["transition:color 0.14s ease;cursor:pointer;color:", ";"], (0, _helpers.color)("purple100"));

  var ModalButton = function ModalButton(props) {
    return _react.default.createElement(StyledSans, _extends({
      pl: 4,
      size: "3",
      weight: "medium"
    }, props));
  };

  return _react.default.createElement(_Modal.Modal, {
    show: show,
    onClose: onClose,
    modalWidth: _Modal.ModalWidth.Narrow,
    hideCloseButton: true
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Flex.Flex, {
    flexDirection: "column"
  }, _react.default.createElement(_Typography.Sans, {
    size: "4",
    weight: "medium",
    mb: 10
  }, title), detail && _react.default.createElement(_Typography.Sans, {
    size: "3",
    color: "black60"
  }, detail)), _react.default.createElement(_Flex.Flex, {
    mt: 3,
    justifyContent: "flex-end"
  }, secondaryCta && _react.default.createElement(ModalButton, {
    secondary: true,
    onClick: secondaryCta.action
  }, secondaryCta.text), _react.default.createElement(ModalButton, {
    onClick: primaryCta.action
  }, primaryCta.text))));
};

exports.Dialog = Dialog;
Dialog.displayName = "Dialog";
Dialog.displayName = "Dialog";
//# sourceMappingURL=Dialog.js.map